import { render } from "./ImpressaoTransferencia.vue?vue&type=template&id=304731e6&scoped=true"
import script from "./ImpressaoTransferencia.vue?vue&type=script&lang=js"
export * from "./ImpressaoTransferencia.vue?vue&type=script&lang=js"

import "./ImpressaoTransferencia.vue?vue&type=style&index=0&id=304731e6&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304731e6"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTable,QTd,QInput});
